/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_BadgeInputs */

const en_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple Pricing`)
};

const es_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios simples`)
};

const fr_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarification simple`)
};

const de_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfache Preisgestaltung`)
};

const ja_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シンプルな料金体系`)
};

const zh_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简单透明的定价`)
};

const ar_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسعار بسيطة`)
};

const id_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Sederhana`)
};

const it_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi Semplici`)
};

const ru_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Простые тарифы`)
};

const pt_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços Simples`)
};

const ko_pricing_hero_badge = /** @type {(inputs: Pricing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`심플한 요금제`)
};

/**
* | output |
* | --- |
* | "Simple Pricing" |
*
* @param {Pricing_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_badge = /** @type {((inputs?: Pricing_Hero_BadgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_BadgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_hero_badge(inputs)
	if (locale === "es") return es_pricing_hero_badge(inputs)
	if (locale === "fr") return fr_pricing_hero_badge(inputs)
	if (locale === "de") return de_pricing_hero_badge(inputs)
	if (locale === "ja") return ja_pricing_hero_badge(inputs)
	if (locale === "zh") return zh_pricing_hero_badge(inputs)
	if (locale === "ar") return ar_pricing_hero_badge(inputs)
	if (locale === "id") return id_pricing_hero_badge(inputs)
	if (locale === "it") return it_pricing_hero_badge(inputs)
	if (locale === "ru") return ru_pricing_hero_badge(inputs)
	if (locale === "pt") return pt_pricing_hero_badge(inputs)
	return ko_pricing_hero_badge(inputs)
});